<div class="gray-bg-rounded orders-list">
  <div
    class="order-line-sticky-header d-flex align-items-center justify-content-between pb-3">
    <div class="align-items-center d-flex">
      <h2 class="mb-0">Line items</h2>
      <div
        class="lds-ring inline me-auto ms-2"
        *ngIf="showSmallLoader || smallLoader">
        <jni-spinner></jni-spinner>
      </div>
      <div
        *ngIf="
          salesOrderStatusD365.toLowerCase() !== 'invoiced' &&
          userBlockedFromEdit &&
          !hideButtonsOnPageLoad &&
          isAddLineButtonVisible
        "
        class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="redirectToLineItem()">
          <i class="pi pi-plus"></i> Add Line</a
        >
      </div>

      <div
        *ngIf="
          salesOrderLine.length &&
          salesOrderStatusD365.toLowerCase() !== 'invoiced' &&
          checkOrderIsConfirmed() &&
          getAvailableCreditBtnStatus &&
          userBlockedFromEdit &&
          isLineEditDisabled
        "
        class="ms-3 nav-link d-flex align-items-center btncommit">
        <a class="link" (click)="confirmAllLines()">
          <i class="pi pi-comment"></i> Commit
          {{ isAnyUnCommitLinesEvent() }}</a
        >
      </div>
      <div
        *ngIf="
          salesOrderLine.length &&
          salesOrderStatusD365.toLowerCase() !== 'invoiced' &&
          !checkOrderIsConfirmed() &&
          isSaleOrderLineConfirmStatus &&
          getAvailableCreditBtnStatus &&
          userBlockedFromEdit &&
          isLineEditDisabled
        "
        class="ms-3 nav-link d-flex align-items-center btncommit">
        <a class="link" (click)="syncCopiedSalesOrderLines()"
          ><b>Commit</b> {{ isAnyUnCommitLinesEvent() }}</a
        >
      </div>
    </div>

    <div
      class="prospects-panel d-flex justify-content-between align-items-center ms-2 me-2"
      *ngIf="isFromOrderSummary">
      <span style="font-weight: 600">Sort </span>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radiobutton
          id="Dflt"
          class="me-2"
          name="radio"
          value="Dflt"
          [(ngModel)]="defaultSortSelection"
          (onClick)="getLinesFiltersOnChange($event)" />

        <span class="link">Dflt</span>
      </label>

      <label
        class="ms-2 nav-link p-0 d-flex align-items-center"
        *ngIf="orderType !== 'inventory-sales'">
        <p-radiobutton
          *ngIf="orderType !== 'inventory-sales'"
          id="Po"
          class="me-2"
          name="radio"
          value="Po"
          [(ngModel)]="defaultSortSelection"
          (onClick)="getLinesFiltersOnChange($event)" />

        <span class="link" *ngIf="orderType !== 'inventory-sales'">PO</span>
      </label>

      <label
        class="ms-2 nav-link p-0 d-flex align-items-center"
        *ngIf="orderType !== 'inventory-sales'">
        <p-radiobutton
          *ngIf="orderType !== 'inventory-sales'"
          id="VendorPo"
          class="me-2"
          name="radio"
          value="VendorPo"
          [(ngModel)]="defaultSortSelection"
          (onClick)="getLinesFiltersOnChange($event)" />

        <span class="link" *ngIf="orderType !== 'inventory-sales'"
          >Vendor/PO</span
        >
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radiobutton
          id="InHands"
          class="me-2"
          name="radio"
          value="InHands"
          [(ngModel)]="defaultSortSelection"
          (onClick)="getLinesFiltersOnChange($event)" />

        <span class="link">In Hands</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <p-radiobutton
          id="OrigLn"
          class="me-2"
          name="radio"
          value="OrigLn"
          [(ngModel)]="defaultSortSelection"
          (onClick)="getLinesFiltersOnChange($event)" />

        <span class="link">OrigLn#</span>
      </label>
    </div>

    <div class="orders-panel col-auto d-flex justify-content-between">
      <!-- <a class="link-gray" (click)="onAddNewLine()"
        ><i class="icon-Add"></i> Add new</a
      > -->

      <div
        class="ms-2 nav-link p-0 d-flex align-items-center"
        *ngIf="salesOrderLine.length > 0 && !isCdi">
        <a (click)="updateOrderLineItemSequence()" class="link pe-1"
          >Save Line Sequence</a
        >
      </div>

      <div
        class="ms-2 nav-link p-0 d-flex align-items-center"
        *ngIf="
          salesOrderStatusD365?.toLowerCase() !== 'invoiced' &&
          userBlockedFromEdit
        ">
        <a class="icon-Notes icon"></a>
      </div>

      <div
        class="ms-2 nav-link p-0 d-flex align-items-center"
        *ngIf="
          salesOrderStatusD365?.toLowerCase() !== 'invoiced' &&
          userBlockedFromEdit
        ">
        <i class="pi pi-paperclip icon-blue mx-1"></i>
      </div>

      <div
        class="ms-2 nav-link p-0 d-flex align-items-center"
        *ngIf="
          salesOrderStatusD365?.toLowerCase() !== 'invoiced' &&
          userBlockedFromEdit
        ">
        <a class="link pe-1">Use</a> / <a class="link ps-1">Make</a>
      </div>
      <div
        class="ms-3 nav-link p-0 d-flex align-items-center delete"
        *ngIf="
          salesOrderStatusD365?.toLowerCase() !== 'invoiced' &&
          userBlockedFromEdit &&
          !hideButtonsOnPageLoad &&
          isAddLineButtonVisible
        ">
        <div *ngIf="!deleteButtonStatus">
          <i class="pi pi-trash delcol mx-1"></i>
          <a class="link delcol" (click)="onDeleteButton()">Delete</a>
        </div>
      </div>
      <div
        class="ms-3 nav-link p-0 d-flex align-items-center"
        *ngIf="
          (!isCdi || (isCdi && selectedSaleOrderLine?.length)) &&
          salesOrderStatusD365?.toLowerCase() !== 'invoiced' &&
          userBlockedFromEdit &&
          !hideButtonsOnPageLoad &&
          isAddLineButtonVisible
        ">
        <i class="pi pi-clone icon-blue mx-1"></i>
        <a class="link" (click)="showModalDialog()">Copy Lines</a>
      </div>

      <jni-copy-lines
        #copyline
        [displayModal]="displayModal"
        (closeDialogEvent)="closeModalDialog()"
        [saleOrderId]="OrderLineId"
        (refreshGridEvent)="refreshGrid()"></jni-copy-lines>

      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <i class="pi pi-cloud-upload icon-blue mx-1"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </div>

  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [value]="salesOrderLine"
    [(selection)]="selectedSaleOrderLine"
    styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg cstm-table-hover no-overfollow"
    [rowHover]="true"
    [rows]="5"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="salesOrderLine.id"
    editMode="row"
    selectionMode="multiple"
    (onRowSelect)="hideDeleteLineButton()"
    (onRowUnselect)="hideDeleteLineButton()"
    selectionMode="multiple"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th *ngIf="!isCdi"></th>
        <th *ngIf="!isCdi"></th>
        <th class="col-center text-center">
          <p-tableHeaderCheckbox
            (click)="hideDeleteLineButton()"></p-tableHeaderCheckbox>
        </th>
        <th class="number text-center">#</th>
        <th class="notes text-center">Notes</th>
        <th class="trackable text-center">
          <!-- <input
          class="form-check-input"
          type="checkbox"
          (click)="selectedUnselectAllTrackable($event)"
          id="check"
        /> -->

          <div
            class="custom-width-switch d-flex justify-content-center align-items-center">
            <div
              class="form-check form-switch d-flex align-items-center m-0 gap-1">
              <span class="ms-2">Track</span>
              <p-toggleswitch
                type="checkbox"
                id="trackable"
                name="trackable"
                (onChange)="selectedUnselectAllTrackable($event)" />
            </div>
          </div>
        </th>
        <th
          class="vendor-sku"
          [style.display]="orderType === 'inventory-sales' ? 'none' : ''">
          Vendor Sku
        </th>
        <th class="vendor-sku">
          {{
            this.orderType === "inventory-sales" ? "Item Number" : "Category"
          }}
        </th>
        <th
          class="vendor-sku"
          [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
          {{
            this.orderType === "inventory-sales"
              ? "Product Name"
              : "Category Name"
          }}
        </th>
        <th [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
          Color
        </th>
        <th [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
          Size
        </th>
        <th [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
          Style
        </th>
        <th [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
          Config
        </th>
        <th class="description">Description</th>
        <th class="unmatched">UnMat</th>
        <th class="quantity">Qty</th>
        <th class="sell">Sell</th>
        <th class="sell-total">Sell Total</th>
        <th class="net">Net</th>
        <th class="net">Net Total</th>
        <th class="net">Net Gp%</th>
        <th class="status">Status</th>
        <th
          *ngIf="!isCdi"
          [style.display]="orderType === 'inventory-sales' ? 'none' : ''"
          style="width: 100px"
          class="vendor-name">
          Vendor Name
        </th>
        <th
          *ngIf="!isCdi"
          [style.display]="orderType === 'inventory-sales' ? 'none' : ''"
          class="vendor-name">
          PO#
        </th>
        <th
          *ngIf="!isCdi"
          [style.display]="orderType === 'inventory-sales' ? 'none' : ''"
          class="vendor-name">
          PO Assign
        </th>
      </tr>
      <tr *ngIf="isCdi">
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="salesOrderLine.externalItemNumberD365"
              id="salesOrderLine.externalItemNumberD365"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'salesOrderLine.externalItemNumberD365',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="salesOrderLine.lineDescriptionD365"
              id="salesOrderLine.lineDescriptionD365"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'salesOrderLine.lineDescriptionD365',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <!-- <th></th>
        <th></th>
        <th ></th> -->
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-salesOrderLine
      let-editing="editing"
      let-ri="rowIndex"
      let-rowIndex="rowIndex">
      <ng-container>
        <tr
          [pReorderableRow]="rowIndex"
          [ngClass]="{ odd: !getOddEvenNumber(ri), even: getOddEvenNumber(ri) }"
          class="p-selectable-row"
          [pEditableRow]="salesOrderLine"
          [pSelectableRow]="salesOrderLine"
          (dblclick)="
            editLine(
              salesOrderLine.salesOrderLine.id,
              salesOrderLine.salesOrderLine.vendorDirectDeliveryD365,
              salesOrderLine.salesOrderLine.vendorPoAssignmentD365,
              salesOrderLine.salesOrderLine.lineStatusD365
            )
          ">
          <td *ngIf="!isCdi">
            <span
              class="pi pi-bars"
              pReorderableRowHandle
              style="cursor: move"></span>
          </td>
          <td *ngIf="!isCdi">
            <div class="eddel-btn d-flex align-items-center">
              <button
                *ngIf="!editing"
                [disabled]="
                  !userBlockedFromEdit ||
                  salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                    'invoiced' ||
                  salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                    'delivered'
                "
                type="button"
                pInitEditableRow
                pButton
                pRipple
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text"
                (click)="
                  onEditRow(
                    salesOrderLine.salesOrderLine.vendorDirectDeliveryD365,
                    salesOrderLine.salesOrderLine.vendorPoAssignmentD365,
                    salesOrderLine.salesOrderLine.lineStatusD365,
                    salesOrderLine.salesOrderLine.id,
                    salesOrderLine.salesOrderLine
                  )
                "></button>
              <button
                *ngIf="editing"
                type="button"
                pSaveEditableRow
                pButton
                pRipple
                icon="pi pi-check"
                (click)="onRowEditSave(salesOrderLine.salesOrderLine)"
                class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color selectable-color"></button>
              <button
                *ngIf="editing"
                type="button"
                pCancelEditableRow
                pButton
                pRipple
                (click)="refreshGrid()"
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger"></button>
            </div>
          </td>
          <td class="col-center text-center">
            <p-tableCheckbox
              [pSelectableRow]="salesOrderLine"
              [value]="salesOrderLine"></p-tableCheckbox>
          </td>
          <td
            class="number text-center"
            (click)="
              onRedirectToLinePage(
                salesOrderLine.salesOrderLine.lineNumberD365,
                salesOrderLine.salesOrderLine.id,
                salesOrderLine.salesOrderLine.purchaseOrderD365
              )
            ">
            <a class="link line-number">{{
              salesOrderLine.salesOrderLine.lineNumberD365
            }}</a>
          </td>
          <td class="notes text-center">
            <a class="me-1">{{ salesOrderLine.salesOrderLine.notes }}</a>
            <a><i class="pi pi-file-check"></i></a>
          </td>
          <td class="trackable">
            <!-- <span class="me-1">{{
              salesOrderLine.salesOrderLine.attachement
            }}</span>
            <i class="pi pi-paperclip icon-blue mx-1"></i> -->

            <!-- <div class="form-group switcher">
              <div class="form-check form-switch d-flex align-items-center m-0">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  id="trackable"
                  name="trackable"
                  [(ngModel)]=" salesOrderLine.salesOrderLine.isTrackable"
                  [disabled]="salesOrderLine.salesOrderLine.lineDescriptionD365.toLowerCase() ===	'set up'"
                />
              </div>
            </div> -->

            <div class="custom-width-switch d-flex justify-content-center">
              <div class="d-flex align-items-center m-0">
                <p-toggleswitch
                  id="trackable"
                  name="trackable"
                  [(ngModel)]="salesOrderLine.salesOrderLine.isTrackable"
                  [disabled]="
                    salesOrderLine?.salesOrderLine?.itemNumberD365?.toLowerCase() ===
                      'set up' ||
                    salesOrderLine?.salesOrderLine?.itemNumberD365?.toLowerCase() ===
                      'setup' ||
                    salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'invoiced' ||
                    salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'delivered'
                  "
                  (onChange)="
                    updateOrderLineTrackable(salesOrderLine.salesOrderLine)
                  " />
              </div>
            </div>
          </td>
          <td
            class="vendor-sku"
            [style.display]="orderType === 'inventory-sales' ? 'none' : ''">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [disabled]="
                    externalItemNumberD365 ||
                    isCdi ||
                    (salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'open order' &&
                      salesOrderLine?.salesOrderLine?.deliverRemainderD365 <
                        salesOrderLine?.salesOrderLine
                          ?.orderedPurchaseQuantityD365)
                  "
                  style="width: 5rem"
                  [(ngModel)]="
                    salesOrderLine.salesOrderLine.externalItemNumberD365
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine.salesOrderLine.externalItemNumberD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  id="currency"
                  [disabled]="
                    itemNumberD365 ||
                    isCdi ||
                    (salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'open order' &&
                      salesOrderLine?.salesOrderLine?.deliverRemainderD365 <
                        salesOrderLine?.salesOrderLine
                          ?.orderedPurchaseQuantityD365)
                  "
                  [appendTo]="'body'"
                  [(ngModel)]="salesOrderLine.salesOrderLine.itemNumberD365"
                  (onChange)="
                    itemSelected($event, salesOrderLine.salesOrderLine)
                  "
                  [options]="getDropdownOptions(salesOrderLine)"
                  optionLabel="itemNumberD365"
                  optionValue="itemNumberD365">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine?.salesOrderLine?.itemNumberD365 }}
              </ng-template>
            </p-cellEditor>
            <!-- {{ salesOrderLine.salesOrderLine.itemNumberD365 }} -->
          </td>
          <td
            [style.display]="orderType !== 'inventory-sales' ? 'none' : ''"
            pTooltip="{{ salesOrderLine?.salesOrderLine?.categoryName }}"
            [tooltipOptions]="toolTipOptions">
            <div class="hoverwdth">
              {{ salesOrderLine?.salesOrderLine?.categoryName }}
            </div>
          </td>
          <td [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  id="color"
                  [appendTo]="'body'"
                  [(ngModel)]="salesOrderLine.salesOrderLine.color"
                  (clear)="generateDescription(salesOrderLine.salesOrderLine)"
                  [disabled]="!filteredColors.length"
                  (onChange)="
                    generateDescription(salesOrderLine.salesOrderLine)
                  "
                  [options]="filteredColors">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine?.salesOrderLine?.color }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  id="size"
                  [appendTo]="'body'"
                  [(ngModel)]="salesOrderLine.salesOrderLine.size"
                  (clear)="generateDescription(salesOrderLine.salesOrderLine)"
                  [disabled]="!filteredSizes.length"
                  (onChange)="
                    generateDescription(salesOrderLine.salesOrderLine)
                  "
                  [options]="filteredSizes">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine?.salesOrderLine?.size }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  id="size"
                  [appendTo]="'body'"
                  [(ngModel)]="salesOrderLine.salesOrderLine.style"
                  (clear)="generateDescription(salesOrderLine.salesOrderLine)"
                  [disabled]="!filteredStyles.length"
                  (onChange)="
                    generateDescription(salesOrderLine.salesOrderLine)
                  "
                  [options]="filteredStyles">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine?.salesOrderLine?.style }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td [style.display]="orderType !== 'inventory-sales' ? 'none' : ''">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  id="size"
                  [appendTo]="'body'"
                  [(ngModel)]="salesOrderLine.salesOrderLine.config"
                  (clear)="generateDescription(salesOrderLine.salesOrderLine)"
                  [disabled]="!filteredConfigs.length"
                  (onChange)="
                    generateDescription(salesOrderLine.salesOrderLine)
                  "
                  [options]="filteredConfigs">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine?.salesOrderLine?.config }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            class="description text-truncate hoverwdth"
            [ngClass]="{
              'trimmeddescription trimmedby50char': descriptionCharacterCond,
            }"
            pTooltip="{{ salesOrderLine.salesOrderLine.lineDescriptionD365 }}"
            [tooltipOptions]="toolTipOptions">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [disabled]="
                    salesOrderLine?.salesOrderLine?.proposalIdD365 !== '' ||
                    salesOrderStatusD365.toLowerCase() === 'invoiced' ||
                    salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'invoiced'
                  "
                  [(ngModel)]="
                    salesOrderLine.salesOrderLine.lineDescriptionD365
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{
                  descriptionCharacterCount(
                    salesOrderLine.salesOrderLine.lineDescriptionD365
                  )
                }}
                {{ salesOrderLine.salesOrderLine.lineDescriptionD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="number unmatched">
            <a
              class="link image-center"
              (click)="
                openUrlDialog(
                  salesOrderLine.salesOrderLine.purchaseOrderD365,
                  salesOrderLine?.salesOrderLine
                )
              "
              [class.disabled]="
                !userBlockedFromEdit ||
                salesOrderLine?.salesOrderLine?.deliverRemainderD365 ===
                  salesOrderLine?.salesOrderLine?.orderedPurchaseQuantityD365 ||
                (salesOrderLine?.salesOrderLine?.purchasePriceD365 === 0 &&
                  (salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                    'invoiced' ||
                    salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'delivered'))
              ">
              <span
                *ngIf="
                  salesOrderLine.salesOrderLine.deliverRemainderD365 !== null
                    ? salesOrderLine.salesOrderLine.deliverRemainderD365 !== 0
                    : salesOrderLine.salesOrderLine
                        .orderedPurchaseQuantityD365 !== 0
                ">
                {{
                  salesOrderLine.salesOrderLine.deliverRemainderD365 !== null
                    ? salesOrderLine.salesOrderLine.deliverRemainderD365
                    : salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365
                }}
              </span>
              <i
                class="pi pi-receipt"
                *ngIf="
                  salesOrderLine.salesOrderLine.deliverRemainderD365 !== null
                    ? salesOrderLine.salesOrderLine.deliverRemainderD365 === 0
                    : salesOrderLine.salesOrderLine
                        .orderedPurchaseQuantityD365 === 0
                "></i>
            </a>
          </td>
          <td class="quantity">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  style="width: 3rem"
                  [(ngModel)]="
                    salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365
                  "
                  (focusout)="
                    calculateQuantity(
                      salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365,
                      salesOrderLine.salesOrderLine
                    )
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365 }}
              </ng-template>
            </p-cellEditor>
            <!-- {{ salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365 }} -->
          </td>
          <td class="sell">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  style="width: 4rem"
                  [disabled]="
                    salesOrderLine?.salesOrderLine?.proposalIdD365 !== '' ||
                    salesOrderStatusD365.toLowerCase() === 'invoiced' ||
                    salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'invoiced'
                  "
                  [(ngModel)]="salesOrderLine.salesOrderLine.sellD365"
                  (focusout)="
                    calculateSell(
                      salesOrderLine.salesOrderLine.sellD365,
                      salesOrderLine.salesOrderLine
                    )
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{
                  salesOrderLine.salesOrderLine.sellD365
                    | currency: foreignCurrency : "symbol" : "0.3-3"
                }}
              </ng-template>
            </p-cellEditor>
            <!-- {{ salesOrderLine.salesOrderLine.sell | number }} -->
          </td>
          <td class="sell-total">
            {{
              salesOrderLine.salesOrderLine.sellTotalD365
                | currency: foreignCurrency : "symbol" : "1.2-2"
            }}
          </td>
          <td class="net">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  style="width: 4rem"
                  [disabled]="
                    !salesOrderLine.salesOrderLine.vendorDirectDeliveryD365 ||
                    purchasePriceD365 ||
                    (salesOrderLine.salesOrderLine.deliverRemainderD365 !== null
                      ? salesOrderLine.salesOrderLine.deliverRemainderD365 === 0
                      : salesOrderLine.salesOrderLine
                          .orderedPurchaseQuantityD365 === 0) ||
                    (salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'open order' &&
                      salesOrderLine?.salesOrderLine?.deliverRemainderD365 <
                        salesOrderLine?.salesOrderLine
                          ?.orderedPurchaseQuantityD365) ||
                    orderType === 'inventory-sales' ||
                    !salesOrderLine.salesOrderLine.vendorNameD365
                  "
                  [(ngModel)]="salesOrderLine.salesOrderLine.purchasePriceD365"
                  (focusout)="
                    onNetConversion(
                      salesOrderLine.salesOrderLine.purchasePriceD365,
                      salesOrderLine.salesOrderLine
                    )
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{
                  salesOrderLine.salesOrderLine.purchasePriceD365
                    | currency
                      : salesOrderLine.salesOrderLine.currencyCodeD365
                      : "symbol"
                      : "0.4-4"
                }}
              </ng-template>
            </p-cellEditor>
            <!-- {{ salesOrderLine.salesOrderLine.purchasePriceD365 | number }} -->
          </td>
          <td class="net" style="text-align: right">
            {{
              salesOrderLine?.salesOrderLine?.netTotalD365
                | currency
                  : salesOrderLine.salesOrderLine.currencyCodeD365
                  : "symbol"
                  : "1.2-2"
            }}
          </td>
          <td style="white-space: nowrap">
            {{
              getNetGpPercentage(
                salesOrderLine?.salesOrderLine?.netTotalD365 === null
                  ? salesOrderLine?.salesOrderLine?.netTotalD365
                  : salesOrderLine?.salesOrderLine?.netTotalD365,
                salesOrderLine?.salesOrderLine?.sellTotalD365
              ) | number: "1.2-2"
            }}
            <span
              *ngIf="
                salesOrderLine?.salesOrderLine?.sellTotalD365 &&
                (salesOrderLine?.salesOrderLine?.netTotalD365 ||
                  salesOrderLine?.salesOrderLine?.netTotalD365)
              ">
              {{ percentageSign }}
            </span>
          </td>
          <td class="status">
            {{ salesOrderLine.salesOrderLine.lineStatusD365 }}
          </td>
          <td
            *ngIf="!isCdi"
            class="vendor-name"
            style="width: 100px"
            [style.display]="orderType === 'inventory-sales' ? 'none' : ''">
            {{ salesOrderLine.salesOrderLine.vendorNameD365 }}
          </td>
          <td
            *ngIf="!isCdi"
            [style.display]="orderType === 'inventory-sales' ? 'none' : ''">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  id="currency"
                  [appendTo]="'body'"
                  [disabled]="
                    disabledPoNumber ||
                    isCdi ||
                    (salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'open order' &&
                      salesOrderLine?.salesOrderLine?.deliverRemainderD365 <
                        salesOrderLine?.salesOrderLine
                          ?.orderedPurchaseQuantityD365)
                  "
                  [(ngModel)]="salesOrderLine.salesOrderLine.purchaseOrderD365"
                  [options]="purchaseOrderIdList"
                  optionLabel="PurchaseOrderId"
                  optionValue="PurchaseOrderId">
                </p-select>
              </ng-template>
              <ng-template
                pTemplate="output"
                *ngIf="orderType !== 'inventory-sales'">
                <a
                  class="link"
                  (click)="
                    openPdfScreen(
                      salesOrderLine.salesOrderLine.purchaseOrderD365,
                      salesOrderLine.salesOrderLine.salesOrderIdD365
                    )
                  ">
                  {{ salesOrderLine.salesOrderLine.purchaseOrderD365 }}</a
                >
              </ng-template>
            </p-cellEditor>
            <!-- {{ salesOrderLine.salesOrderLine.purchaseOrderD365 }} -->
          </td>
          <td
            *ngIf="!isCdi"
            [style.display]="orderType === 'inventory-sales' ? 'none' : ''">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  [appendTo]="'body'"
                  id="currency"
                  [disabled]="
                    vendorPoAssignmentD365 ||
                    isCdi ||
                    (salesOrderLine?.salesOrderLine?.lineStatusD365?.toLowerCase() ===
                      'open order' &&
                      salesOrderLine?.salesOrderLine?.deliverRemainderD365 <
                        salesOrderLine?.salesOrderLine
                          ?.orderedPurchaseQuantityD365)
                  "
                  (onChange)="
                    onPoNumberChange(
                      salesOrderLine.salesOrderLine.vendorPoAssignmentD365,
                      salesOrderLine.salesOrderLine.id
                    )
                  "
                  [(ngModel)]="
                    salesOrderLine.salesOrderLine.vendorPoAssignmentD365
                  "
                  [options]="poAssigment"
                  optionLabel="name"
                  optionValue="name">
                </p-select>
              </ng-template>
              <ng-template
                pTemplate="output"
                *ngIf="orderType !== 'inventory-sales'">
                {{ salesOrderLine.salesOrderLine.vendorPoAssignmentD365 }}
              </ng-template>
            </p-cellEditor>
            <!-- {{ salesOrderLine.salesOrderLine.vendorPoAssignmentD365 }} -->
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No line item found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<jni-unmatch-url-dialog
  [displayModal]="unmatchQuantityStatus"
  *ngIf="vendorInvoiceJournalDetail?.length"
  (closeDialogEvent)="closeUrlDialog()"
  [vendorInvoiceJournalDetail]="
    vendorInvoiceJournalDetail
  "></jni-unmatch-url-dialog>

<jni-modal-stacker
  *ngIf="orderLineDisplayModal"
  [displayModal]="orderLineDisplayModal"
  (closeEvent)="closeModalConditionalRefresh()">
  <h1 class="panelHeading">Order Line</h1>
  <div class="panelBody">
    <jni-order-line-item
      [saleOrderIdFromModal]="OrderLineId"
      [orderLineNumberFromModal]="orderLineNumber"
      [saleOrderModalStatus]="saleOrderModalStatus"
      [viewPoNumber]="viewPoNumber"
      (closeEvent)="closeModal()"
      (closeModalNoRefresh)="closeModalNoRefresh()"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (lineGridRefresh)="refreshLineGrid()"
      [isPartiallyInvoicedOrderLines]="isPartiallyInvoicedOrderLines"
      [selectedSaleOrderLine]="selectedSaleOrderLine"
      [orderType]="orderType"
      [addNewLineCase]="addNewLineCase"
      [shippingProductsList]="shippingProductsList"
      [isModal]="true"
      (closeSalesOrderLineEvent)="closeModalConditionalRefresh()"
      [saleOrderData]="saleOrderData"
      [isFromCdi]="fromCDI"
      (updateSalesOrderLineDtoEvent)="
        updateSalesOrderLineDtoEvent($event)
      "></jni-order-line-item>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="poEmailDisplayModal"
  [displayModal]="poEmailDisplayModal"
  (closeEvent)="closeModalForPoEmail()"
  class="modal-header-sticky">
  <h1 class="panelHeading mt-5"></h1>
  <div class="panelBody">
    <jni-po-email
      [poEmailData]="poEmailData"
      (closePOEmailModalEvent)="closeModalForPoEmail()"
      [isModal]="true"></jni-po-email>
  </div>
</jni-modal-stacker>

<jni-confirm-dialog
  [dialogMessage]="popUpMessage"
  dialogHeading="Delete Confirmation"
  *ngIf="dialogStatus"
  (confirmDialogStatus)="confirmDialogStatusData($event)">
</jni-confirm-dialog>

<div class="p-d-flex p-flex-column p-ai-center">
  <p-dialog
    [modal]="true"
    [(visible)]="showWarningTrackleAllDialog"
    appendTo="body">
    <ng-template pTemplate="header">
      <div class="inline-flex items-center justify-center gap-2">
        <span
          class="font-bold whitespace-nowrap"
          style="font-size: 21px; font-weight: bold"
          >Warning
        </span>
        <i class="pi pi-exclamation-triangle"></i>
      </div>
    </ng-template>

    <div class="p-fluid p-dir-col p-p-3">
      <div class="p-field p-mb-2 field-wrap">
        <label
          class="text-bold matchMode form-group has-float-label mb-1"
          style="font-size: 15px"
          >Are you sure you want to make trackable
          <span style="font-weight: bold">{{ isTrackableAllChecked }}</span> on
          below line numbers?</label
        >
        <span
          *ngFor="let obj of salesOrderLineTrackable"
          style="font-size: 14px">
          {{ obj?.salesOrderLine?.lineNumberD365 }},
        </span>
      </div>
      <div
        class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
        <button
          class="btn btn-secondary me-5"
          type="button"
          (click)="cancelTrackable()">
          No
        </button>
        <button
          class="btn btn-primary"
          type="submit"
          (click)="saveAllTrackable()">
          Yes
        </button>
      </div>
    </div>
  </p-dialog>
</div>

<div class="p-d-flex p-flex-column p-ai-center">
  <p-dialog
    appendTo="body"
    [modal]="true"
    icon="pi pi-exclamation-triangle"
    [(visible)]="showWarningCategoryChangedDialog">
    <ng-template pTemplate="header">
      <div class="inline-flex items-center justify-center gap-2">
        <span
          class="font-bold whitespace-nowrap"
          style="font-size: 21px; font-weight: bold"
          >Warning
        </span>
        <i class="pi pi-exclamation-triangle"></i>
      </div>
    </ng-template>

    <div class="p-fluid p-dir-col p-p-3">
      <div class="p-field p-mb-2 field-wrap">
        <label
          class="text-bold matchMode form-group has-float-label mb-1"
          style="font-size: 15px"
          >Changing the category on a confirmed line might clear some existing
          data.</label
        >
      </div>
      <div
        class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
        <button
          class="btn btn-secondary"
          type="button"
          (click)="okCategoryChangedDialog()">
          Ok
        </button>
      </div>
    </div>
  </p-dialog>
</div>
